var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[(_vm.showPage)?_c('div',{staticClass:"index"},[_c('ranking-tab',{attrs:{"period":_vm.current}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }